/**
 * 全域 UI 層級 (Z-Index) 定義
 * 確保各類組件堆疊順序邏輯化，避免隱形遮罩攔截點擊事件
 */
export const Z_INDEX = {
    BASE: 0,
    // 一般下拉選單、氣泡彈窗 (Popover)、右鍵選單 (ContextMenu)
    DROPDOWN: 1000,
    MENU: 1000,

    // 對話框 (Dialog)、側邊欄 (Sidebar)
    DIALOG: 1100,

    // 工具提示 (Tooltip)，確保高於對話框
    TOOLTIP: 1110,

    // 系統角落通知 (Toast)
    TOAST: 1200,

    // 業務邏輯重要訊息 (Messenger) - 必須高於 Toast 以確保「X」可點擊
    MESSENGER: 1300,

    // 強制性全景遮罩或緊急通知
    FORCE_OVERLAY: 2000
} as const;

// 匯出型別供必要時使用
export type ZIndexType = typeof Z_INDEX;